import React from 'react'

const WorkOneImageRow = (props) =>{


    //console.log("WorkOneImageRow",props);



    if(props.item.options.full_height_image === true){

      let backgroundStyle={
              backgroundImage: `url(${props.item.image.url})`,
              backgroundPosition: props.item.options.image_anchor
        }

        return (<div className="content-row one-image">
                         <div className="full-height-image" style={backgroundStyle} />
                         <div className={"caption "+( props.item.caption.colour)}>
                            <div className="inner" dangerouslySetInnerHTML={{__html:props.item.caption.caption_text}} />
                          </div>
              </div>);

    }else{

      return (<div className="content-row one-image">
                           <img src={props.item.image.url} alt="" />
                           <div className={"caption "+( props.item.caption.colour)}>
                              <div className="inner" dangerouslySetInnerHTML={{__html:props.item.caption.caption_text}} />
                            </div>
                </div>);

    }



}

export default WorkOneImageRow;


// WEBPACK FOOTER //
// ./src/modules/work/WorkOneImageRow.js